import { useFormAddProductsToCart } from '@graphcommerce/magento-product'
import { useWatch } from '@graphcommerce/react-hook-form'
import { usePromotions } from '../../../lib/promotions/usePromotions'
import { useGetCurrentProductQtyFromCart } from '../ProductAddToCart/useGetCurrentProductQtyFromCart'
import { ProductPageItemsFragment } from '../graphql/ProductPageItems.gql'
import { PromotionMessage } from './PromotionMessage'
import { PromotionQtyAlert } from './PromotionQtyAlert'

type ProductPagePromotionWrapperProps = {
  index?: number
  product: NonNullable<NonNullable<ProductPageItemsFragment['items']>[number]>
}

export const ProductPagePromotionWrapper = (props: ProductPagePromotionWrapperProps) => {
  const { product, index = 0 } = props
  const { sku, label_qty, label_percent, promotion_type, promotion_id, promotion_name, has_cart_rule, has_catalog_rule } = product
  const { control } = useFormAddProductsToCart()
  const currentQty = useWatch({ control, name: `cartItems.${index}.quantity` })
  const maxQty = 10
  const { cartData } = useGetCurrentProductQtyFromCart({})
  const promotions = usePromotions({ items: cartData?.cart?.items })
  const cartItem = cartData?.cart?.items?.find((item) => item?.product.sku === sku)
  const cartItemQty = cartItem?.quantity
  const cartPromotionQty = promotion_id ? promotions[promotion_id] : cartItemQty
  const remainingQty = cartItemQty ? maxQty - cartItemQty : maxQty
  const isPromotionProduct = Boolean(has_cart_rule || has_catalog_rule)

  return (
    isPromotionProduct && (
      <>
        <PromotionQtyAlert qty={currentQty} max={maxQty} remaining={remainingQty} />
        {cartPromotionQty && promotion_name && (
          <PromotionMessage
            qty={currentQty}
            cartPromotionQty={cartPromotionQty}
            cartItemQty={cartItemQty}
            label_qty={label_qty}
            label_percent={label_percent}
            promotion_type={promotion_type}
            promotion_name={promotion_name}
          />
        )}
      </>
    )
  )
}
